import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Price from '../Price/Price';
import {SizeName, SizeContent} from './Size.style';

export class Size extends PureComponent {
  render() {
    const {name, price, callback, index, selectedSize} = this.props;
    const selectSize = () => callback(index);

    return (
      <SizeName onClick={selectSize}>
        <SizeContent isSelected={selectedSize === name}>
          {name} <Price amount={price} />
        </SizeContent>
      </SizeName>
    );
  }
}

Size.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  callback: PropTypes.func.isRequired,
  selectedSize: PropTypes.string.isRequired
};

export default Size;



// WEBPACK FOOTER //
// ./components/Meal/Size.js